import type { ChangelogEntry } from "../types";

/** Oppdateringsvarselet kommer bare når det gjelder deg, ellers høyst én gang i døgnet. */
export const FAERRE_OPPDATERINGSVARSLER_2026_10: ChangelogEntry = {
  id: "2026-10-26-faerre-oppdateringsvarsler",
  date: "2026-10-26",
  title: "Færre varsler om å laste inn på nytt",
  summary:
    "Varselet «Revehiet er oppdatert» kom ved hver oppdatering. Nå kommer det med en gang bare når det er en nyhet du får tilgang til, og ellers høyst én gang i døgnet.",
  sections: [
    {
      heading: "Oppdateringer",
      items: [
        {
          title: "Varsel bare for nyheter du får tilgang til",
          kind: "forbedret",
          body: "Er det en ny utrulling i «Nytt i Revehiet» som gjelder deg, står tittelen i varselet, og det kommer med en gang. Rettinger og arbeid som ennå ikke er rullet ut til deg, varsles høyst én gang i døgnet.",
        },
      ],
    },
  ],
};
